<script setup>
import { computed, inject } from 'vue'

// Section heading inside a ToolRail. Shows the label text when expanded; when
// collapsed it degrades to a thin separator (suppressed for the first section
// via `:divider="false"` so the rail doesn't start with a leading line).

defineProps({
  label: {
    type: String,
    required: true
  },
  divider: {
    type: Boolean,
    default: true
  }
})

const railExpanded = inject('railExpanded', null)
const expanded = computed(() => (railExpanded ? railExpanded.value : false))
</script>

<template>
  <li class="rail-section" aria-hidden="true">
    <div v-if="expanded" class="rail-section-header">{{ label }}</div>
    <div v-else-if="divider" class="rail-separator"></div>
  </li>
</template>
